import tr from './tr.json';
import en from './en.json';
import de from './de.json';
import fr from './fr.json';
import nl from './nl.json';

import dk from './dk.json';
import it from './it.json';
import sa from './sa.json';
import ir from './ir.json';
import ru from './ru.json';

import FlaggeIconTurk from '../assets/lang/tr.png';
import FlaggeIconGerman from '../assets/lang/de.png';
import FlaggeIconEnglish from '../assets/lang/en.png';
import FlaggeIconFrance from '../assets/lang/fr.png';
import FlaggeIconNetherlands from '../assets/lang/nl.png';
import FlaggeIconDenmark from '../assets/lang/dk.png';
import FlaggeIconItaly from '../assets/lang/it.png';
import FlaggeIconSaudi from '../assets/lang/sa.png';
import FlaggeIconIran from '../assets/lang/ir.png';
import FlaggeIconRussia from '../assets/lang/ru.png';

export const dictionaryList = {tr, de, nl, en, fr, dk, it, sa, ir, ru };

export const languageOptions = {
  tr: FlaggeIconTurk ,
  de: FlaggeIconGerman,
  nl: FlaggeIconNetherlands,
  en: FlaggeIconEnglish ,
  fr: FlaggeIconFrance,
  dk: FlaggeIconDenmark,
  it: FlaggeIconItaly,
  sa: FlaggeIconSaudi,
  ir: FlaggeIconIran,
  ru: FlaggeIconRussia,

};